/**
 * Reload decision for the OCR activity tray.
 *
 * Background OCR/import runs for minutes; when the last in-flight file leaves
 * the active-jobs list the page is stale (new invoices/statements, bundle tree,
 * folders). Reload once — but never while the type-mismatch dialog is waiting
 * for the user's choice, otherwise the warning would vanish unanswered.
 */
export function queueJustDrained(prevCount: number, nextCount: number): boolean {
  return prevCount > 0 && nextCount === 0;
}

export function shouldReloadAfterDrain(
  prevCount: number,
  nextCount: number,
  mismatchPending: boolean,
): boolean {
  return queueJustDrained(prevCount, nextCount) && !mismatchPending;
}
